import React from 'react';
import { Jumbotron, Button } from 'reactstrap';
import './hero1.css';

// border: https://getbootstrap.com/docs/4.1/utilities/borders/#border-radius
// const PARAGRAPH1 = 'Our hours are Tuesday to Friday, 9:00 AM to 6:00 PM, and Saturdays, 9:00 AM to 5:00 PM. Please wear a facial covering. Masks and hand sanitizer are provided at the door.';
const PARAGRAPH1 = 'Our hours are Tuesday to Saturdays, 10:00 AM to 5:00 PM. Please wear a facial covering. Masks and hand sanitizer are provided at the door.';
const PARAGRAPH2 = 'For helmet, we will give you a disposable balaclava for try-ons. You are welcome to bring your own balaclava. Helmets are disinfected regularly.';
const PARAGRAPH3 = 'If we are at capacity, we will ask you to wait downstairs in Ducati Richmond. There is a seating area in the Scrambler department for you to relax while you wait.';
const PARAGRAPH4 = 'Be kind, be calm, be safe. Thank you for understanding!';

const hero1 = (props) => {
    return (
        <div>
            <Jumbotron className='hero-image-jumbotron rounded-0 text-white'>
                <h1 className="display-5">Winter hours!</h1>
                <div class="alert alert-secondary alert-background" role="alert">
                    <p className="lead">
                        <strong>{PARAGRAPH1 && PARAGRAPH1}
                            {/*<br /><br />*/}
                            {/*{PARAGRAPH2 && PARAGRAPH2}*/}
                            {/*<br /><br />*/}
                            {/*{PARAGRAPH3 && PARAGRAPH3}*/}
                            {/*<br /><br />*/}
                            {/*{PARAGRAPH4 && PARAGRAPH4}*/}
                        </strong>
                    </p>
                </div>
                {/*<hr className="my-2" />
                <p>It uses utility classes for typography and spacing to space content out within the larger container.<br />
                    <a href='https://getbootstrap.com/docs/4.1/content/typography/'>https://getbootstrap.com/docs/4.1/content/typography/</a><br />
                    <a href='https://getbootstrap.com/docs/4.1/utilities/colors/'>https://getbootstrap.com/docs/4.1/utilities/colors/</a>
                </p>
                <p className="lead">
                    <Button color="primary">Continue on Facebook</Button>
                </p>*/}
            </Jumbotron>
        </div>
    );
};

export default hero1;


// WEBPACK FOOTER //
// ./src/components/HeroImage/hero1.js